import { FormGroup, Validators } from "@angular/forms";

import { isEmpty } from "lodash";

import { CommunicationMethodTypeCode, PROTOCOL_FORM_PARAMS } from "src/app/models/protocol/protocol.model";

export function setProtocolFormValues(formGroup: FormGroup, entity: any) {
  if (!entity) {
    return;
  }


  if (!formGroup|| isEmpty(formGroup.controls)) {
    return;
  }

  const { communicationMethodTypeCode, communicationMethodData } = entity;

  if (formGroup.controls.forecourtEventClientIp && formGroup.controls.forecourtEventClientPort) {
    formGroup.controls.forecourtEventClientIp.setValue(entity.additionalData.forecourtEventClientIp);
    formGroup.controls.forecourtEventClientPort.setValue(entity.additionalData.forecourtEventClientPort);
  }
  
  switch (communicationMethodTypeCode) {
    case CommunicationMethodTypeCode.IP_PROTOCOL:
      formGroup.controls?.communicationMethodTypeCode?.setValue(communicationMethodTypeCode);
      formGroup.controls?.ipAddress?.setValue(communicationMethodData.ipAddress);
      formGroup.controls?.port?.setValue(communicationMethodData.port);
      disableFields(formGroup, [
        PROTOCOL_FORM_PARAMS.address, 
          PROTOCOL_FORM_PARAMS.baudRate,
          PROTOCOL_FORM_PARAMS.address, 
          PROTOCOL_FORM_PARAMS.deviceId,
          PROTOCOL_FORM_PARAMS.maxBlockLength,
          PROTOCOL_FORM_PARAMS.heartBeatInterval,
          PROTOCOL_FORM_PARAMS.localNodeAddress,
          PROTOCOL_FORM_PARAMS.logicalDeviceId,
          PROTOCOL_FORM_PARAMS.subnet,
          PROTOCOL_FORM_PARAMS.node,
          PROTOCOL_FORM_PARAMS.stopBits,
          PROTOCOL_FORM_PARAMS.parity,
          PROTOCOL_FORM_PARAMS.dataBits,
          PROTOCOL_FORM_PARAMS.handshake,
          PROTOCOL_FORM_PARAMS.timeout
      ]);
      enableFields(formGroup, [PROTOCOL_FORM_PARAMS.ipAddress, PROTOCOL_FORM_PARAMS.port]);
      break;
    case CommunicationMethodTypeCode.SERIAL_CONNECTION:
      formGroup.controls?.communicationMethodTypeCode?.setValue(communicationMethodTypeCode);
      formGroup.controls?.address?.setValue(communicationMethodData.address);
      formGroup.controls?.baudRate?.setValue(communicationMethodData.baudRate);
      formGroup.controls?.parity?.setValue(communicationMethodData.parity);
      formGroup.controls?.dataBits?.setValue(communicationMethodData.dataBits);
      formGroup.controls?.stopBits?.setValue(communicationMethodData.stopBits);
      formGroup.controls?.handshake?.setValue(communicationMethodData.handshake);
      formGroup.controls?.timeout?.setValue(communicationMethodData.timeout);
      disableFields(formGroup, [ 
        PROTOCOL_FORM_PARAMS.ipAddress, 
        PROTOCOL_FORM_PARAMS.port,
        PROTOCOL_FORM_PARAMS.deviceId,
        PROTOCOL_FORM_PARAMS.heartBeatInterval,
        PROTOCOL_FORM_PARAMS.localNodeAddress,
        PROTOCOL_FORM_PARAMS.maxBlockLength,
        PROTOCOL_FORM_PARAMS.recipientAddressTable
      ]);
      enableFields(formGroup, [
        PROTOCOL_FORM_PARAMS.address, 
        PROTOCOL_FORM_PARAMS.baudRate,
        PROTOCOL_FORM_PARAMS.stopBits,
        PROTOCOL_FORM_PARAMS.parity,
        PROTOCOL_FORM_PARAMS.dataBits,
        PROTOCOL_FORM_PARAMS.handshake,
        PROTOCOL_FORM_PARAMS.timeout
      ]);
      break;
    case CommunicationMethodTypeCode.LON_CONNECTION:
      formGroup.controls?.communicationMethodTypeCode?.setValue(communicationMethodTypeCode);
      formGroup.controls?.address?.setValue(communicationMethodData.address);
      formGroup.controls?.port?.setValue(communicationMethodData.port);
      formGroup.controls?.deviceId?.setValue(communicationMethodData.deviceId);
      formGroup.controls?.maxBlockLength?.setValue(communicationMethodData.maxBlockLength);
      formGroup.controls?.heartBeatInterval?.setValue(communicationMethodData.heartBeatInterval);
      formGroup.controls?.localNodeAddress?.setValue(
        {
          logicalDeviceId: communicationMethodData?.localNodeAddress?.logicalDeviceId,
          subnet: communicationMethodData?.localNodeAddress?.subnet,
          node: communicationMethodData?.localNodeAddress?.node
        }
      );
      disableFields(formGroup, [
        PROTOCOL_FORM_PARAMS.ipAddress,
        PROTOCOL_FORM_PARAMS.baudRate,
        PROTOCOL_FORM_PARAMS.stopBits,
        PROTOCOL_FORM_PARAMS.dataBits,
        PROTOCOL_FORM_PARAMS.handshake,
        PROTOCOL_FORM_PARAMS.timeout,
        PROTOCOL_FORM_PARAMS.parity
      ]);
      enableFields(formGroup, [
        PROTOCOL_FORM_PARAMS.address, 
        PROTOCOL_FORM_PARAMS.deviceId, 
        PROTOCOL_FORM_PARAMS.port,
        PROTOCOL_FORM_PARAMS.maxBlockLength,
        PROTOCOL_FORM_PARAMS.heartBeatInterval,
        PROTOCOL_FORM_PARAMS.localNodeAddress,
        PROTOCOL_FORM_PARAMS.logicalDeviceId,
        PROTOCOL_FORM_PARAMS.subnet,
        PROTOCOL_FORM_PARAMS.node
      ]);
      break;
    default:
      break;
  }
}

export function disableFields(form: FormGroup, formFields: string[], clearValues = true) {
  formFields.forEach((field) => {
    form.get(field)?.clearValidators();
    form.get(field)?.updateValueAndValidity();
    if (clearValues) {
      form.get(field)?.setValue(null);
    }
    form.get(field)?.disable();
  });
}


export function enableFields(form: FormGroup, formFields: string[]) {
  formFields.forEach((field) => {
    switch (field) {
      case PROTOCOL_FORM_PARAMS.ipAddress:
        form.get(field)?.setValidators([Validators.required]);
        break;
      case PROTOCOL_FORM_PARAMS.port:
        form.get(field)?.setValidators([Validators.required, Validators.min(1), Validators.max(65535), Validators.pattern('^[0-9]+$')]);
        break;
      case PROTOCOL_FORM_PARAMS.address:
        form.get(field)?.setValidators([Validators.required, Validators.min(0), Validators.max(255)]);
        break;
      case PROTOCOL_FORM_PARAMS.baudRate:
        form.get(field)?.setValidators([Validators.required, Validators.min(0), Validators.max(100000)]);
        break;
      case PROTOCOL_FORM_PARAMS.deviceId:
        form.get(field)?.setValidators([Validators.required, Validators.min(0)]);
        break;
      case PROTOCOL_FORM_PARAMS.maxBlockLength:
        form.get(field)?.setValidators([Validators.required]);
        break;
      case PROTOCOL_FORM_PARAMS.heartBeatInterval:
        form.get(field)?.setValidators([Validators.required]);
        break;
      case PROTOCOL_FORM_PARAMS.localNodeAddress:
        form.get(field)?.setValidators([Validators.required]);
        break;
      case PROTOCOL_FORM_PARAMS.node:
        form.get(field)?.setValidators([Validators.required, Validators.min(0), Validators.pattern('^[0-9]+$')]);
        break;
      case PROTOCOL_FORM_PARAMS.subnet:
        form.get(field)?.setValidators([Validators.required, Validators.min(0), Validators.pattern('^[0-9]+$')]);
        break;
      case PROTOCOL_FORM_PARAMS.logicalDeviceId:
        form.get(field)?.setValidators([Validators.required, Validators.min(0), Validators.pattern('^[0-9]+$')]);
        break;
      case PROTOCOL_FORM_PARAMS.dataBits:
        form.get(field)?.setValidators([Validators.min(5), Validators.max(8), Validators.pattern('^[0-9]+$')]);
        break;
      case PROTOCOL_FORM_PARAMS.timeout:
        form.get(field)?.setValidators([Validators.min(1), Validators.pattern('^[0-9]+$')]);
        break;
      default: 
        break;
    }
    form.get(field)?.updateValueAndValidity();
    form.get(field)?.enable();
  });
}


export function setCommunicationMethodData(protocolFormGroup: FormGroup) {
  if (protocolFormGroup.get(PROTOCOL_FORM_PARAMS.communicationMethodTypeCode)?.value === 'SERIAL_CONNECTION') {
    return {
      address: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.address)?.value ?? null,
      baudRate: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.baudRate)?.value ?? null,
      parity: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.parity)?.value ?? null,
      stopBits: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.stopBits)?.value ?? null,
      dataBits: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.dataBits)?.value ?? null,
      handshake: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.handshake)?.value ?? null,
      timeout: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.timeout)?.value ?? null
    };
  } else if (protocolFormGroup.get(PROTOCOL_FORM_PARAMS.communicationMethodTypeCode)?.value === 'IP_PROTOCOL') {
    return {
      ipAddress: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.ipAddress)?.value ?? null,
      port: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.port)?.value ?? null,
    };
  } else {
    return{
      address: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.address)?.value ?? null,
      port: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.port)?.value ?? null,
      deviceId: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.deviceId)?.value ?? null,
      maxBlockLength: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.maxBlockLength)?.value ?? null,
      heartBeatInterval: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.heartBeatInterval)?.value ?? null,
      localNodeAddress: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.localNodeAddress)?.value ?? null,
      recipientAddressTable: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.recipientAddressTable)?.value ?? null
    }
  }
}
